import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCanbanIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="current"
      fillRule="evenodd"
      d="M18.776 4.49H5.224c-1.185 0-2.146.96-2.146 2.146v10.729c0 1.185.96 2.146 2.146 2.146h13.552c1.185 0 2.146-.961 2.146-2.146V6.635c0-1.184-.96-2.145-2.146-2.145M5.224 3.417a3.22 3.22 0 0 0-3.219 3.219v10.729a3.22 3.22 0 0 0 3.219 3.218h13.552a3.22 3.22 0 0 0 3.219-3.218V6.635a3.22 3.22 0 0 0-3.219-3.218z"
      clipRule="evenodd"
    />
    <path
      fill="current"
      fillRule="evenodd"
      d="M5.54 6.414c0-.296.24-.537.536-.537H8.99a.536.536 0 0 1 0 1.073H6.076a.536.536 0 0 1-.536-.536M14.595 6.414c0-.296.24-.537.537-.537h2.914a.536.536 0 1 1 0 1.073h-2.914a.536.536 0 0 1-.537-.536M12.536 4.49v15.02h-1.072V4.49zM8.51 9.129H6.557a1 1 0 0 0-1 1v.684a1 1 0 0 0 1 1H8.51a1 1 0 0 0 1-1v-.684a1 1 0 0 0-1-1m-1.953-1a2 2 0 0 0-2 2v.684a2 2 0 0 0 2 2H8.51a2 2 0 0 0 2-2v-.684a2 2 0 0 0-2-2zM17.565 9.129h-1.953a1 1 0 0 0-1 1v.684a1 1 0 0 0 1 1h1.953a1 1 0 0 0 1-1v-.684a1 1 0 0 0-1-1m-1.953-1a2 2 0 0 0-2 2v.684a2 2 0 0 0 2 2h1.953a2 2 0 0 0 2-2v-.684a2 2 0 0 0-2-2zM8.51 14.535H6.557a1 1 0 0 0-1 1v.684a1 1 0 0 0 1 1H8.51a1 1 0 0 0 1-1v-.684a1 1 0 0 0-1-1m-1.953-1a2 2 0 0 0-2 2v.684a2 2 0 0 0 2 2H8.51a2 2 0 0 0 2-2v-.684a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCanbanIcon
